import { inject, Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { map } from 'rxjs';

import { createEffectFactory } from '@core/ngrx-legacy';

import { ReportsMetricsHttpClient } from './metrics.http-client';
import { ReportsMetricsActions } from './metrics.store';

@Injectable()
export class ReportsMetricsEffects {
  private readonly actions$ = inject(Actions);
  private readonly http = inject(ReportsMetricsHttpClient);

  public effects = createEffectFactory(ReportsMetricsActions, this.actions$);

  public fetchCollection$ = this.effects(ReportsMetricsActions.fetchCollection, () =>
    this.http.fetchCollection().pipe(map(({ metrics }) => ({ data: metrics }))),
  );
}
